export const ApiData = {
    getSupplyData() {
        return [
            {
                "id": "1000",
                "name": "John Doe",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.1',
                "RPMO": '11.1',
                "alignment":'2',
                'type': 'Supply',
                "opportunities": 1000,
                "payout": '23,456',
                "supplierCPM": '23,456',
                "revenue": 12000,
                "demandRequests": "10,500",
                "passthrough": "9",
                "fillRate": "30",
                "eRPM": "3.20",
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1002",
                "name": "Jane Smith",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.3',
                'type': 'Supply',
                "opportunities": 800,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 11000,
                "demandRequests": "12,500",
                "passthrough": "11",
                "fillRate": "20",
                "eRPM": "4.29",
                "RPMO": '32.1',
                "alignment":'4',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1003",
                "name": "Bob Johnson",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '1.1',
                'type': 'Demand',
                "opportunities": 1200,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 5000,
                "demandRequests": "11,500",
                "passthrough": "32",
                "fillRate": "23",
                "eRPM": "4.29",
                "RPMO": '1.1',
                "alignment":'2',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1004",
                "name": "John Doe",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '22.1',
                'type': 'Route',
                "opportunities": 1000,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 3000,
                "demandRequests": "41,500",
                "passthrough": "57",
                "fillRate": "50",
                "eRPM": "42.09",
                "RPMO": '13.1',
                "alignment":'3',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1005",
                "name": "Jane Smith",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": "23.3",
                'type': 'Supply',
                "opportunities": 800,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 5000,
                "demandRequests": "11,500",
                "passthrough": "72",
                "fillRate": "70",
                "eRPM": "4.29",
                "RPMO": '11.1',
                "alignment":'2',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1006",
                "name": "Bob Johnson",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.1',
                'type': 'Supply',
                "opportunities": 1200,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 9000,
                "demandRequests": "21,500",
                "passthrough": "65",
                "fillRate": "73",
                "eRPM": "14.29",
                "RPMO": '13.1',
                "alignment":'4',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1007",
                "name": "John Doe",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.1',
                'type': 'Demand',
                "opportunities": 1000,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 1000,
                "demandRequests": "11,500",
                "passthrough": "95",
                "fillRate": "80",
                "eRPM": "4.29",
                "RPMO": '32.1',
                "alignment":'6',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1008",
                "name": "Jane Smith",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": "34.3",
                'type': 'Supply',
                "opportunities": 800,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 2000,
                "demandRequests": "11,500",
                "passthrough": "9",
                "fillRate": "40",
                "eRPM": "4.29",
                "RPMO": '11.1',
                "alignment":'4',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1009",
                "name": "Bob Johnson",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.1',
                'type': 'Route',
                "opportunities": 1200,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 4000,
                "demandRequests": "11,500",
                "passthrough": "45",
                "fillRate": "40",
                "eRPM": "4.29",
                "RPMO": '32.1',
                "alignment":'6',
                "actions": ["Edit", "Delete"]
            },
            {
                "id": "1010",
                "name": "Bob Johnson",
                "supplyPartnerName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "demandName": "AE_IH_PLL_WeatherBug_RTB_SLITE_07DEC21",
                "RPMR": '2.1',
                'type': 'Demand',
                "opportunities": 1200,
                "payout": "23,456",
                "supplierCPM": '$ 23,456',
                "revenue": 12000,
                "demandRequests": "11,500",
                "passthrough": "32",
                "fillRate": "40",
                "eRPM": "4.29",
                "RPMO": '31.1',
                "alignment":'3',
                "actions": ["Edit", "Delete"]
            }
        ];
    },
    getSupportData() {
        return [
            {
                "ticketId": "102",
                "ticketTitle": "Can't add new supply",
                "dateCreated": "15 Dec 2023",
                "status": "Open"
            },
            {
                "ticketId": "273",
                "ticketTitle": "Can't edit existing demand",
                "dateCreated": "29 Nov 2023",
                "status": "Pending"
            },
            {
                "ticketId": "317",
                "ticketTitle": "Can't change demand margin",
                "dateCreated": "16 Oct 2023",
                "status": "Closed"
            },
            {
                "ticketId": "498",
                "ticketTitle": "Can't add blocked categories",
                "dateCreated": "9 Sep 2023",
                "status": "Open"
            }
        ]
    },
    getUserData() {
        return [
            {
                "fullName": "John Doe",
                "email": "john.doe@acme.com",
                "role": "Admin",
                "designation": "Product Manager",
                "status": "Active"
            },
            {
                "fullName": "Brad Pitt",
                "email": "brad.pitt@acme.com",
                "role": "Report",
                "designation": "CEO",
                "status": "Active"
            },
            {
                "fullName": "George Clooney",
                "email": "george.clooney@acme.com",
                "role": "Supply",
                "designation": "CMO",
                "status": "Active"
            },
            {
                "fullName": "Jennifer Lawrence",
                "email": "jennifer.lawrence@acme.com",
                "role": "Supply",
                "designation": "Supply Ops Specialist",
                "status": "Active"
            },
            {
                "fullName": "Zendaya",
                "email": "zendaya@acme.com",
                "role": "Demand",
                "designation": "Supply Ops Specialist",
                "status": "Active"
            },
            {
                "fullName": "Lily Collins",
                "email": "lily.collins@acme.com",
                "role": "Demand",
                "designation": "Demand Ops Specialist",
                "status": "Active"
            },
            {
                "fullName": "Matt Damon",
                "email": "matt.damon@acme.com",
                "role": "Demand",
                "designation": "Demand Ops Specialist",
                "status": "Disabled"
            },
            {
                "fullName": "Katherine Heigl",
                "email": "katherine.heigl@acme.com",
                "role": "Billing",
                "designation": "Demand Ops Specialist",
                "status": "Disabled"
            }
        ]
    },
    getBillingHistory() {
        return [
            {
                "date": "1 February, 2024",
                "billingItem": "john.doe@acme.com",
                "charges": "$26,394",
                "status": "Pending",
                "invoice": "Invoice.pdf",
            },
            {
                "date": "1 January, 2024",
                "billingItem": "brad.pitt@acme.com",
                "charges": "$14,966",
                "status": "Pending",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 December, 2023",
                "billingItem": "george.clooney@acme.com",
                "charges": "$9,033",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 November, 2023",
                "billingItem": "jennifer.lawrence@acme.com",
                "charges": "$5,205",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 October, 2023",
                "billingItem": "jennifer.lawrence@acme.com",
                "charges": "$5,205",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 September, 2023",
                "billingItem": "jennifer.lawrence@acme.com",
                "charges": "$5,205",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 August, 2023",
                "billingItem": "jennifer.lawrence@acme.com",
                "charges": "$5,205",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            },
            {
                "date": "1 July, 2023",
                "billingItem": "jennifer.lawrence@acme.com",
                "charges": "$5,205",
                "status": "Paid",
                "invoice": "Invoice.pdf"
            }
        ]
    },
    getSupplyPartner() {
        return [{
            "id": 1500,
            "supplyPartnerName": "BIGO Ads ",
            "domain": "ads.com",
            "contactName": "",
            "contactEmail": "",
            "supplyPartnerDiscription": "",
            "publicNameForSupplyPartner": "supplypartner",
            "sellerType": "rtb",
            "isConfidential": false
        }, {
            "id": 1501,
            "supplyPartnerName": "Applovin Ads",
            "domain": "",
            "contactName": "Jerome Tran",
            "contactEmail": "jerome.tran@applovin.com",
            "supplyPartnerDiscription": "",
            "publicNameForSupplyPartner": "",
            "sellerType": "",
            "isConfidential": false
        }]
    },
    getSupplyPartners() {
        return Promise.resolve(this.getSupplyPartner());
    },
    getSupply() {
        return Promise.resolve(this.getSupplyData());
    },
    getSupport() {
        return Promise.resolve(this.getSupportData());
    },
    getUser() {
        return Promise.resolve(this.getUserData());
    },
    getBilling() {
        return Promise.resolve(this.getBillingHistory());
    }
};

